// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableHead {
  background-color: "#E5E7F3";
}

.tableCellHead {
  width: 5%;
  padding: 5px;
}

.tableHeadCellSortUnit {
  width: 18.5%;
  padding: 5px;
}

.tableHeadCellSortUnitImg {
  margin-right: 5px;
  stroke: #001489;
}

.tableHeadCheckBox {
  width: 12%;
  padding: 5px;
}

.tableHeadCheckBoxPosition {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.mainTablePaper {
  width: 100%;
  border: 2px solid rgb(229, 231, 243);
}

.bgWhite {
  background-color: white;
}

.noRecords {
  width: 100px;
  margin-top: 15px;
  margin-left: 7px;
}
.noRecordsInterchanges {
  margin-top: 15px;
  margin-left: 7px;
  margin-bottom: 10px;
}

.tablePagination {
  background-color: rgb(229, 231, 243) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/dataTable/TableView.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".tableHead {\n  background-color: \"#E5E7F3\";\n}\n\n.tableCellHead {\n  width: 5%;\n  padding: 5px;\n}\n\n.tableHeadCellSortUnit {\n  width: 18.5%;\n  padding: 5px;\n}\n\n.tableHeadCellSortUnitImg {\n  margin-right: 5px;\n  stroke: #001489;\n}\n\n.tableHeadCheckBox {\n  width: 12%;\n  padding: 5px;\n}\n\n.tableHeadCheckBoxPosition {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.mainTablePaper {\n  width: 100%;\n  border: 2px solid rgb(229, 231, 243);\n}\n\n.bgWhite {\n  background-color: white;\n}\n\n.noRecords {\n  width: 100px;\n  margin-top: 15px;\n  margin-left: 7px;\n}\n.noRecordsInterchanges {\n  margin-top: 15px;\n  margin-left: 7px;\n  margin-bottom: 10px;\n}\n\n.tablePagination {\n  background-color: rgb(229, 231, 243) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
